module.exports = __webpack_public_path__ + "static/img/no_data5.827d49b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/no_data5.png
// module id = Efe2
// module chunks = 169